import * as React from 'react';
import { Compare as IconCompare } from '../../Icons/';
import { Icon } from '../Icon';
import { checkCompareEnabled } from '../../../utils/checkCompareEnabled';
import { trackingCompareIconClick } from './tracking';
import { CompareOnboarding } from './parts/CompareOnboarding';
import { incrementCompareOnboardingCounter, isCompareOnboardingEnabled } from './helpers';
import { IApplicationState } from '../../../types/state';

interface ICompareProps {
  section?: IApplicationState['section'];
}

export const Compare = ({ section }: ICompareProps) => {
  const onboardingEnabled = React.useMemo(() => isCompareOnboardingEnabled(), []);
  const [onboardingOpened, setOnboardingOpened] = React.useState(onboardingEnabled);
  const isCompare = section === 'compare';
  const enabled = React.useMemo(() => checkCompareEnabled(), []);
  const handleClick = React.useCallback(trackingCompareIconClick, []);

  React.useEffect(() => {
    incrementCompareOnboardingCounter(onboardingEnabled && enabled && !isCompare);
  });

  if (!enabled) {
    return null;
  }

  return (
    <>
      <Icon onClick={handleClick} iconView={<IconCompare />} link={'/compare/'} title="Сравнение объектов" />
      {onboardingOpened && !isCompare && (
        <CompareOnboarding
          onClose={() => {
            setOnboardingOpened(false);
          }}
        />
      )}
    </>
  );
};
